import { useEffect, useState, useContext } from "react";
import { Theme } from "./Features";
import { Button } from "../../Components";
import { Link, useHistory, useParams } from "react-router-dom";
import { Domain } from "../../Entities/Domain";
import { dataContext } from "../../Context";
import { Idomain } from "../../Interfaces";
import { IoIosArrowBack } from "react-icons/io";
import "./Expertise.css";
import useWindowDimensions from "../../Hooks/useWindowDimensions";

const EXPERTISE_DOMAIN_INDEX = 0;

const Expertise = () => {
  const [data, setData] = useState<Set<string>>(new Set());
  const [domain, setDomain] = useState<Idomain[]>([]);
  const [buttonHoverClass, setButtonHoverClass] = useState<string | null>(null);
  const [enableScore, setEnableScore] = useState<string>("disable");
  const { datas } = useContext(dataContext);
  const { tribu } = useParams<{ tribu: string }>();
  const history = useHistory();
  const { width } = useWindowDimensions();
  const isMobile = width <= 500;

  const parseData = async (domains: Set<string>) => {
    const domain = new Domain(domains);
    const domainParsed = domain.getAllDomains();

    parseDomainData(domainParsed);
    setData(domainParsed);
  };

  const parseDomainData = (domainParsed: Set<string>) => {
    if (domainParsed) {
      //Get last answer per expertise domain
      const newDomain: Idomain[] = Array.from(domainParsed).map(
        (element: string) => {
          //filter on experstise domain last answer
          const questionLenght = Array.from(datas as Array<string[]>).filter(
            (filterdata: string[]) => {
              return filterdata[EXPERTISE_DOMAIN_INDEX] === element;
            }
          );

          return { name: element, value: questionLenght.length };
        }
      );

      setDomain(newDomain);
    }
  };

  const handleOnClick = () => {
    history.push("/result");
  };

  useEffect(() => {
    if (datas.length) {
      parseData(datas);
    }

    // eslint-disable-next-line
  }, [datas]);

  return (
    <div className="expertise">
      <div className="tinyHeader">
        <div className="back">
          <Link to={"/tribu"}>
            {isMobile ? <IoIosArrowBack /> : <p>Retour</p>}
          </Link>
        </div>
        <div className="evalComp">
          <h2 className="evalCompTribe">Tribu {tribu}</h2>
          <p className="evalCompCatchphrase">Évalue tes compétences </p>
        </div>
      </div>
      <div>
        <h3 className="selectComp">
          Sélectionne un domaine d’expertise pour commencer ton auto-évaluation
        </h3>
        <div className="expertiseList">
          <Theme
            setEnableScore={setEnableScore}
            listDomain={data}
            tribu={tribu}
            data={domain}
          />
        </div>
        <div className={`resultFooter-${enableScore}`}>
          <div
            onMouseEnter={() => {
              setButtonHoverClass("buttonHover");
            }}
            onMouseLeave={() => {
              setButtonHoverClass(null);
            }}
          >
            <Button
              title="Mon Score"
              onClick={handleOnClick}
              hover={buttonHoverClass}
              disabled={enableScore}
            ></Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Expertise;
